import { EventModel} from "../../models/EventModel";

export class EventInteractPlanModel extends EventModel {
	constructor() {
		super();

		this.prices = [];
	}
}
